const SELECTORS = {
    host: "[data-mb-contact-page] #app-embed",
    language: "custom#language",
};

function getCurrentLanguage() {
    // var candidates = [
    //     document.documentElement.getAttribute('lang'),
    //     navigator.language,
    //     navigator.userLanguage
    // ];

    // for (var i = 0; i < candidates.length; i++) {
    //     var lang = (candidates[i] || '').toLowerCase();
    // }
    return document.documentElement.getAttribute('lang')
 
}


function setFieldValue(el, value) {
    el.value = value;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
}

function hideField(el) {
    var wrapper =
        el.closest('[data-field]') ||
        el.closest('.field') ||
        el.closest('div');

    if (wrapper) wrapper.style.display = 'none';
    else el.style.display = 'none';
}


function setLanguageField(root) {
    const languageField = root.getElementById(SELECTORS.language);
    if (!languageField) return; 
    setFieldValue(languageField, getCurrentLanguage());
    hideField(languageField);
}



function StyleUI(root) {
    const heading = root.querySelector('h2');
    const header = heading ? heading.closest('section') : null;
    if (header) {
        header.style.display = 'none';
    }

    const submitBtn = root.querySelector('button[type="submit"]')
    if (submitBtn) {
        submitBtn.style.fontSize = '18px'
    }

    const disclaimer = root.querySelector('._formDisclaimer_cit2d_38 p')
    if (disclaimer) {
        disclaimer.style.fontSize = '14px'
        disclaimer.style.textAlign = 'center'
        disclaimer.style.lineHeight = '140%'
        disclaimer.style.color = '#5A5A5A'


    }

}

function tryInit() {
    const host = document.querySelector(SELECTORS.host);
    if (!host) return false;
    const root = host.shadowRoot;
    if (!root) return false;

    setLanguageField(root);
    StyleUI(root);

    return true;
}

function waitUntilReady(maxWaitMs) {
    const start = Date.now();
    const interval = setInterval(() => {
        if (tryInit() || (Date.now() - start > maxWaitMs)) {
            clearInterval(interval);
        }
    }, 200);
}

waitUntilReady(5000);
